import Header from '@/components/Header';
import { useState, useEffect } from 'react';
import MyTicketsTab from '@/components/MyTicketsTab';
import MyPaymentsTab from '@/components/MyPaymentsTab';
import AccountTab from '@/components/AccountTab';
import SettingsTab from '@/components/SettingsTab';
import LikesTab from '@/components/LikesTab';
import { useParams } from 'react-router-dom';
import MobileBottomNav from '@/components/MobileBottomNav';
import Footer from '@/components/Footer';
import { eyebrow, glow, sectionTitle, pageBg, wrap } from '@/components/ui/design';

const tabOptions = [
    'account', 'tickets', 'likes', 'payments', 'settings'
] as const;
type TabType = typeof tabOptions[number];


export default function Profile() {
    const { tab: urlTab } = useParams<{ tab?: string }>();

    // Initialize with default tab, will be updated when URL changes
    const [tab, setTab] = useState<TabType>('account');

    // Sync tab state with URL on mount and when URL changes
    useEffect(() => {
        const validTab = urlTab && tabOptions.includes(urlTab as TabType) ? urlTab as TabType : 'account';

        if (validTab !== tab) {
            setTab(validTab);
        }
    }, [urlTab, tab]);

    return (
        <div className={`flex min-h-screen flex-col ${pageBg}`}>
            {tab === 'account' ? (
                <Header compactHideIcons compactSwapTheme />
            ) : tab === 'tickets' || tab === 'likes' ? (
                <Header />
            ) : (
                <div className="hidden md:block">
                    <Header />
                </div>
            )}
            <div className="relative isolate flex-1 overflow-hidden">
                <div className={glow} />
                <div className={`${wrap} min-h-[70vh] pt-6 pb-20 md:pt-12`}>
                    <main className="w-full min-h-0">
                        {(tab === 'payments' || tab === 'settings') && (
                            <div className="mb-8 md:mb-10">
                                <p className={eyebrow}>Account</p>
                                <h1 className={`${sectionTitle} mt-3`}>{tab === 'payments' ? 'Payments' : 'Settings'}</h1>
                            </div>
                        )}
                        <div className="min-h-full">
                            {tab === 'account' && (
                                <AccountTab />
                            )}
                            {tab === 'tickets' && (
                                <MyTicketsTab />
                            )}
                            {tab === 'likes' && (
                                <LikesTab />
                            )}
                            {tab === 'payments' && (
                                <MyPaymentsTab />
                            )}
                            {tab === 'settings' && (
                                <SettingsTab />
                            )}
                        </div>
                    </main>
                </div>
            </div>
            <Footer hasMobileNav />
            <MobileBottomNav />
        </div>
    );
}